import React, { useState, useEffect } from 'react';
import { Box, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import Page from '../../components/Layout/Page';
import Header from './Header';
import Results from './Results';
import { getScraperStatus } from '../../requests/api/scrapereports';
import useStyles from './styles';

function Home() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);
  const [reportDate, setReportDate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await getScraperStatus();
        if (response.success && response.data?.data) {
          setRows(response.data.data.rows || []);
          setReportDate(response.data.data.reportDate || null);
        } else {
          enqueueSnackbar('Error al cargar el estado de los scrapers.', {
            variant: 'error',
          });
        }
      } catch {
        setRows([]);
        enqueueSnackbar('Error al cargar el estado de los scrapers.', {
          variant: 'error',
        });
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [enqueueSnackbar]);

  return (
    <Page
      className={classes.root}
      title="FH Engel | Estado scrapers"
    >
      <Container maxWidth="lg">
        <Header reportDate={reportDate} />
        <Box mt={3}>
          <Results status={rows} loading={loading} />
        </Box>
      </Container>
    </Page>
  );
}

export default Home;
